import { DATA_STATES } from '@/store/consts';
import { STATE_KEYS, defaultState } from './state';

const MUTATION_TYPES = {
  SET_MEDALLIA_INITIALIZATION_INFO: 'setMedalliaInitializationInfo',
  SET_DATA_STATE: 'setDataState',
  SET_CONFIGURATION_STEP: 'setConfigurationStep',
  SET_SKILLS: 'setSkills',
  SET_SKILLS_LOADING: 'setSkillsLoadingFlag',
  SET_SURVEYS: 'setSurveys',
  SET_SURVEYS_LOADING: 'setSurveysLoadingFlag',
  SET_CONFIG_SURVEY_INFO: 'setConfigSurveyInfo',
  RESET_CONFIG_SURVEY_INFO: 'resetConfigSurveyInfo',
  SET_SURVEYS_SKILLS: 'setSurveySkills',
  DELETE_SURVEYS_SKILLS: 'deleteSurveySkills',
  DELETE_ALL_SURVEYS_SKILLS: 'deleteAllSurveySkills',
};

const mutations = {
  [MUTATION_TYPES.SET_MEDALLIA_INITIALIZATION_INFO](state, items) {
    state[STATE_KEYS.MEDALLIA_INITIALIZATION_INFO] = items || {};
  },
  [MUTATION_TYPES.SET_DATA_STATE](state, dataState) {
    switch (dataState) {
      case DATA_STATES.SUCCESS: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = Date.now();
        break;
      }
      case DATA_STATES.ERROR: {
        state[STATE_KEYS.ERROR_COUNT] += 1;
        break;
      }
      case DATA_STATES.NONE: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = null;
        break;
      }
      default:
        break;
    }
    state[STATE_KEYS.DATA_STATE] = dataState;
  },
  [MUTATION_TYPES.SET_CONFIGURATION_STEP](state, step = 1) {
    state[STATE_KEYS.CONFIGURATION_STEP] = step;
  },
  [MUTATION_TYPES.SET_SKILLS](state, skills = []) {
    state[STATE_KEYS.SKILLS] = skills;
  },
  [MUTATION_TYPES.SET_SKILLS_LOADING](state, flag) {
    state[STATE_KEYS.SKILLS_LOADING] = flag;
  },
  [MUTATION_TYPES.SET_SURVEYS](state, surveys = []) {
    state[STATE_KEYS.SURVEYS] = surveys;
  },
  [MUTATION_TYPES.SET_SURVEYS_LOADING](state, flag) {
    state[STATE_KEYS.SURVEYS_LOADING] = flag;
  },
  [MUTATION_TYPES.SET_CONFIG_SURVEY_INFO](state, configSurveyInfo = []) {
    state[STATE_KEYS.CONFIG_SURVEY_INFO] = configSurveyInfo;
  },
  [MUTATION_TYPES.RESET_CONFIG_SURVEY_INFO](state) {
    state[STATE_KEYS.CONFIG_SURVEY_INFO] = defaultState[STATE_KEYS.CONFIG_SURVEY_INFO];
  },
  [MUTATION_TYPES.SET_SURVEYS_SKILLS](state, collection) {
    state[STATE_KEYS.SELECTED_SURVEYS_SKILLS] = {
      ...state[STATE_KEYS.SELECTED_SURVEYS_SKILLS],
      ...collection,
    };
  },
  [MUTATION_TYPES.DELETE_SURVEYS_SKILLS](state, surveyId) {
    const { [surveyId]: deleted, ...rest } = state[STATE_KEYS.SELECTED_SURVEYS_SKILLS];

    state[STATE_KEYS.SELECTED_SURVEYS_SKILLS] = { ...rest };
  },
  [MUTATION_TYPES.DELETE_ALL_SURVEYS_SKILLS](state) {
    state[STATE_KEYS.SELECTED_SURVEYS_SKILLS] = [];
  },
};

export {
  mutations,
  MUTATION_TYPES,
};
